import React from "react";
import { useLanguage } from "../../i18n/LanguageContext";

// Owners photo for 'El Arte del Corte'
const IMG_CORTE =
  "https://customer-assets.emergentagent.com/job_corte-tradicional/artifacts/qhzgpvw1_Raul-y-Isabel.jpg";
// Stock seafood for 'Del Mar a tu Mesa'
const IMG_MAR =
  "https://images.unsplash.com/photo-1578935149228-66b184c83e69?crop=entropy&cs=srgb&fm=jpg&w=900&q=80";
// Real interior photo for 'Trato 10/10'
const IMG_TRATO =
  "https://customer-assets.emergentagent.com/job_corte-tradicional/artifacts/to7zr35o_comerdor.jpg";

const IMAGES = [IMG_CORTE, IMG_MAR, IMG_TRATO];

export default function Esencia() {
  const { t } = useLanguage();
  const items = t.esencia.items;

  return (
    <section
      id="esencia"
      data-testid="esencia-section"
      className="relative py-24 md:py-32 border-t border-[#E5E0D8]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 lg:px-16">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 mb-16">
          <div className="lg:col-span-4">
            <div className="eyebrow">{t.esencia.eyebrow}</div>
          </div>
          <div className="lg:col-span-8">
            <h2
              data-testid="esencia-title"
              className="font-serif-display text-4xl md:text-5xl lg:text-6xl tracking-tight text-[#1A1A1A] leading-[1.05]"
            >
              {t.esencia.title}
            </h2>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-12">
          {items.map((item, idx) => (
            <article
              key={idx}
              data-testid={`esencia-item-${idx}`}
              className={`group ${idx === 1 ? "md:mt-16" : ""} ${
                idx === 2 ? "md:mt-8" : ""
              }`}
            >
              <div className="overflow-hidden mb-6">
                <img
                  src={IMAGES[idx]}
                  alt={item.title}
                  className="w-full h-72 md:h-80 object-cover transition-transform duration-700 group-hover:scale-105"
                />
              </div>
              <div className="flex items-baseline gap-3 mb-3">
                <span className="font-mono text-[#8B1E0F] text-xs">
                  0{idx + 1}
                </span>
                <h3 className="font-serif-display text-2xl md:text-3xl text-[#1A1A1A]">
                  {item.title}
                </h3>
              </div>
              <p className="text-[#5C5C5C] leading-relaxed">{item.body}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
